import { render, staticRenderFns } from "./PlanillaDetalle.vue?vue&type=template&id=192c171b&scoped=true&"
import script from "./PlanillaDetalle.vue?vue&type=script&lang=js&"
export * from "./PlanillaDetalle.vue?vue&type=script&lang=js&"
import style0 from "./PlanillaDetalle.vue?vue&type=style&index=0&id=192c171b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192c171b",
  null
  
)

export default component.exports